var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import GarConstants from "../models/GarConstants.js";
import { loadStudiesForStepEpicReducer, resolveQualityAlertsEpicReducer, loadPlanSummaryEpicReducer, loadHypothesisEpicReducer, loadToCheckEmptyScEpicReducer, loadSrmAlertEpicReducer, loadScorecardInsightsEpicReducer, loadMetricCategoriesEpic } from "../epics/GarEpic.js";
import { resetStudiesForStepActionType, loadExperimentInfoTypes, loadScorecardsForStudiesTypes, loadScorecardDataTypes, loadSrmAlertTypes, loadSrmMoorTypes, loadAutoShutDownTypes } from "./GarDucksTypes.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const defaultGARReducerState = {
  studiesForStep: {},
  autoShutDownResult: getDefaultAsyncWrapperObj(),
  srmMoorResult: getDefaultAsyncWrapperObj(),
  hypothesisResult: getDefaultAsyncWrapperObj(),
  srmAlertResult: getDefaultAsyncWrapperObj(),
  resolveAlertResult: getDefaultAsyncWrapperObj(),
  scorecardInsightsResult: {},
  scorecards: {},
  scorecardData: {},
  metricCategories: {},
  garContext: {
    control: "",
    treatment: "",
    effect: void 0,
    insight: void 0,
    scorecard: void 0,
    analysistype: void 0,
    analysisname: void 0,
    category: void 0,
    query: void 0,
    highlight: "",
    showFilterTypes: void 0,
    showOneOff: void 0,
    showDisabled: void 0,
    showRetroAA: void 0,
    showAdditionalProps: void 0,
    filter: void 0,
    scorecardId: void 0
  },
  experimentInfo: getDefaultAsyncWrapperObj(),
  planSummaryResult: getDefaultAsyncWrapperObj(),
  showHypothesis: true,
  emptyScorecardResult: {},
  srmAlertResultMap: {}
};
const reducer = (state = defaultGARReducerState, action) => {
  state = loadStudiesForStepEpicReducer.reduxChange(state, action);
  state = resolveQualityAlertsEpicReducer.reduxChange(state, action);
  state = loadPlanSummaryEpicReducer.reduxChange(state, action);
  state = loadHypothesisEpicReducer.reduxChange(state, action);
  state = loadToCheckEmptyScEpicReducer.reduxChange(state, action);
  state = loadSrmAlertEpicReducer.reduxChange(state, action);
  state = loadScorecardInsightsEpicReducer.reduxChange(state, action);
  state = loadMetricCategoriesEpic.reduxChange(state, action);
  switch (action.type) {
    case GarConstants.SET_USER_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        garContext: action.payload
      });
    case GarConstants.SET_PARTIAL_USER_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        garContext: __spreadValues(__spreadValues({}, state.garContext), action.payload)
      });
    case loadAutoShutDownTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        autoShutDownResult: __spreadProps(__spreadValues({}, state.autoShutDownResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadAutoShutDownTypes.LOADED:
      const result = action;
      return __spreadProps(__spreadValues({}, state), {
        autoShutDownResult: result.payload.result
      });
    case loadSrmMoorTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        srmMoorResult: __spreadProps(__spreadValues({}, state.srmMoorResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadSrmMoorTypes.LOADED:
      const result1 = action;
      return __spreadProps(__spreadValues({}, state), {
        srmMoorResult: result1.payload.result
      });
    case loadSrmAlertTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        srmAlertResult: __spreadProps(__spreadValues({}, state.srmAlertResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadSrmAlertTypes.LOADED:
      const payloadResult = action;
      var newResult = payloadResult.payload.result;
      if (EnvironmentService.parallelSRMWarning()) {
        var resultsExist = false;
        if (state.srmAlertResult.data != null && state.srmAlertResult.data.value.length > 0) {
          resultsExist = true;
          newResult = state.srmAlertResult;
        }
        if (resultsExist && !!payloadResult.payload.result.data) {
          payloadResult.payload.result.data.value.map((w) => {
            newResult.data.value.push(w);
          });
        }
      }
      return __spreadProps(__spreadValues({}, state), {
        srmAlertResult: newResult
      });
    case loadScorecardDataTypes.LOADING:
      const scorecardData = action;
      return __spreadProps(__spreadValues({}, state), {
        scorecardData: __spreadProps(__spreadValues({}, state.scorecardData), {
          [`${scorecardData.payload.control}:${scorecardData.payload.treatment}:${scorecardData.payload.scorecardId}`]: __spreadProps(__spreadValues({}, [`${scorecardData.payload.control}:${scorecardData.payload.treatment}:${scorecardData.payload.scorecardId}`]), {
            status: AsyncRequestStatus.Pending
          })
        })
      });
    case loadScorecardDataTypes.LOADED:
      const data = action;
      return __spreadProps(__spreadValues({}, state), {
        scorecardData: __spreadProps(__spreadValues({}, state.scorecardData), {
          [`${data.payload.control}:${data.payload.treatment}:${data.payload.scorecardId}`]: data.payload.result
        })
      });
    case loadScorecardsForStudiesTypes.LOADING:
      const scorecardDataForStudies = action;
      return __spreadProps(__spreadValues({}, state), {
        scorecards: __spreadProps(__spreadValues({}, state.scorecards), {
          [`${scorecardDataForStudies.payload.studyId}`]: __spreadProps(__spreadValues({}, [`${scorecardDataForStudies.payload.studyId}`]), {
            status: AsyncRequestStatus.Pending
          })
        })
      });
    case loadScorecardsForStudiesTypes.LOADED:
      const scorecardsForStudies = action;
      return __spreadProps(__spreadValues({}, state), {
        scorecards: __spreadProps(__spreadValues({}, state.scorecards), {
          [`${scorecardsForStudies.payload.studyId}`]: scorecardsForStudies.payload.result
        })
      });
    case loadExperimentInfoTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentInfo: __spreadProps(__spreadValues({}, state.experimentInfo), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadExperimentInfoTypes.LOADED:
      const expInfo = action;
      return __spreadProps(__spreadValues({}, state), {
        experimentInfo: expInfo.payload.result
      });
    case resetStudiesForStepActionType:
      return __spreadProps(__spreadValues({}, state), {
        studiesForStep: {}
      });
    default:
      return state;
  }
};
export {
  reducer as default,
  defaultGARReducerState,
  reducer
};
//# sourceMappingURL=Gar.ducks.js.map
